<template>
  <div class="column" :class="{ floating: isPhoneFloating }">
    <web-phone-avatar :name="name" :photo="photo" :active="active" :floating="isPhoneFloating" />
    <!-- <span class="title">{{ name }} </span> -->
    <div class="title__container">
      <a-typography-text v-if="$route?.query?.ticket == ticket?.id" class="title" :ellipsis="{ tooltip: name }" :content="name"/> <!--:class="whatsappVoiceClass"/> -->
    </div>

    <span class="subtitle"> 
      <a-tooltip :title="`Llamada vía ${nameChannel}`">
        <icon-channel
          :type="mediumId"
          :width="16"
        />
      </a-tooltip>
      {{ number }} 
    </span>
    <web-phone-elapsed-time :floating="isPhoneFloating" />
    <!-- <span v-else class="status">00:00</span> -->
    <span class="status" :class="{ 'status-floating': isPhoneFloating }">
      <span v-if="isPhoneFloating && isOverlayOn"> {{ name }} |</span> {{ status }} 
      <span v-if="isPhoneFloating"> | {{ nameChannel}}</span>
    </span>
    <!-- <workspace-acw-card v-if="!isPhoneFloating" /> -->
  </div>
</template>

<script>
import WebPhoneElapsedTime from "./WebPhoneElapsedTime.vue";
import WebPhoneAvatar from "../WebPhoneAvatar.vue";
import { statuses } from "../../common/statuses";
import EventBus from "@/app/shared/utils/eventBus";
// import WorkspaceAcwCard from "@/app/workspace/components/cards/WorkspaceAcwCard";
import { defineComponent, inject } from "vue";
import { CallStatus } from "@/packages/vue-jssip/jssip/phone";
import { ChannelType } from "@/app/shared/utils/enums";

import { WebPhoneState } from "@/packages/webphone/utils/enums";
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";

export default defineComponent({
  components: {
    WebPhoneAvatar,
    // WorkspaceAcwCard,
    WebPhoneElapsedTime,
    IconChannel,
  },
  props: {
    receiver: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
    isOverlayOn: { type: Boolean, default: false },
  },
  setup() {
    const flotante = inject("floating");
    const currentWebPhoneState = inject("currentWebPhoneState");

    const ticket = inject("selectedTicket");
    const channel = inject("selectedChannel");
    const isTicketLoading = inject("isTicketLoading");

    console.log("channelwebphone", channel);
    return {
      currentWebPhoneState,
      flotante,
      WebPhoneState,
      ticket,
      channel,
      isTicketLoading,
    };
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    isPhoneFloating() {
      return this.currentWebPhoneState === WebPhoneState.expanded;
    },
    phoneMetadata() {
      return this.$jssip.phone.meta;
    },
    isCurrentTicket() {
      const ticketId = this.$route.query?.ticket;
      const interactionId = this.$route.query?.interaction;
      // const { ticket, channel_person } = this.$jssip.phone?.meta;
      // return ticketId == ticket && channelId == channel_person;
      return this.$jssip.phone.isCurrentCallTicketInteraction(ticketId, interactionId);
    },
    number() {
      const codeCountry = this.phoneMetadata?.code_country;
      const identifier = this.receiver.number;

      return codeCountry ? `+${codeCountry} ${identifier}` : identifier;
    },
    name() {
      return this.ticket?.client?.name || this.receiver?.name || "No identificado";
    },
    photo() {
      if (this.isCurrentTicket || this.flotante) {
        return this.receiver?.photo;
      }
      return this.ticket?.client?.profile_picture;
    },
    status() {
      if ((this.isCurrentTicket && this.$jssip.phone.status != "none") || this.flotante) {
        return statuses[this.$jssip.phone.status];
      }

      return "Finalizada";
    },
    isCallEnded() {
      return this.$jssip.phone.status === "finished" || this.$jssip.phone.status === "failed";
    },
    isInACall() {
      return (
        this.$jssip.phone.status == CallStatus.InCall ||
        this.$jssip.phone.status == CallStatus.Connecting ||
        this.$jssip.phone.status == CallStatus.Ringing
      );
    },
    isWhatsappVoice() {
      return this.$jssip.phone?.meta?.channel === ChannelType.WhatsappVoice
    },
    isCallConnected() {
      return this.$jssip.phone.status == CallStatus.InCall;
    },
    whatsappVoiceClass() {
      return {
        'whatsapp-voice': this.isWhatsappVoice && this.isCallConnected && !this.isPhoneFloating
      };
    },
    channelId() {
      const channel = this.$jssip.phone?.meta?.channel;
      return channel ? Number(channel) : undefined;
    },
    mediumId() {
      const id = this.channelId;
      if (id === ChannelType.WhatsappVoice) return ChannelType.WhatsappVoice;
      if (id === ChannelType.VoiceInbound) return ChannelType.VoiceInbound;
      return ChannelType.Voice;
    },
    nameChannel() {
      const id = this.mediumId;
      if (id === ChannelType.Voice) {
        return "Telefonía Saliente"
      } else if (id === ChannelType.VoiceInbound) {
        return "Telefonía Entrante"
      } else if (id === ChannelType.WhatsappVoice) {
        return "WhatsApp Voice"
      } else {
        return "Teléfono"
      }
    },
  },
  mounted() {
    EventBus.on("MIC_ON", () => {
      this.handleEnter();
    });
    EventBus.on("MIC_OFF", () => {
      this.handleLeave();
    });
  },
  methods: {
    handleEnter() {
      if (this.readonly) return;
      this.active = true;
    },
    handleLeave() {
      if (this.readonly) return;
      this.active = false;
    },
  },
});
</script>

<style lang="sass" scoped>
@import '../../styles/main'

.column
  color: $black
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  height: 100%
  width: 100%
  gap: 4px
  text-align: center

.floating
  margin: 0

.title
  font-size: 16px
  font-weight: 600
  margin-top: 10px

  &__container
    max-width: 90%
  
.whatsapp-voice
    color: #FFFFFF

.subtitle
  font-size: 14px
  display: inline-flex
  align-items: center
  gap: 2px

.status
  &-floating
    position: absolute
    top: 40px
    z-index: 2

.rotate-90-deg
  transform: rotate(90deg)
</style>
